<template>
    <b-card>
        <template #header>
            <i class="bx bx-layout"></i>
            {{ $t("locations.layout.title") }}
        </template>
        
        <div v-for="(zone,i) in internalValue" :key="i" class="mb-4 border rounded p-3">
            <b-badge variant="info" class="mr-2 float-right">
                {{ $t("locations.layout.zone",{code: zone.code}) }}
            </b-badge>

            <form-input 
                icon="bx-purchase-tag"
                label="locations.layout.label"
                v-model="zone.label"
                :placeholder="$t('locations.layout.zone',{code: zone.code})"
            />

            <div class="row">
                <form-input 
                    type="number"
                    class="col"
                    icon="bx-menu bx-rotate-90"
                    label="locations.layout.racks"
                    v-model.number="zone.racks"
                />
                <span class="col col-1 d-flex align-items-center mt-2">&times;</span>
                <form-input 
                    type="number"
                    class="col"
                    icon="bx-dots-vertical"
                    label="locations.layout.shelves"
                    v-model.number="zone.shelves"
                />
            </div>
            <div class="row">
                <div class="col">
                    <i class='bx bxs-grid' ></i>
                    {{ $t("locations.layout.count",{count: (zone.racks * zone.shelves) || 0}) }}
                </div>
                <div class="col text-right">
                    <b-badge variant="warning" v-if="item.$meta.occupied_zones && item.$meta.occupied_zones[zone.code]">{{ $t("locations.layout.occupied",{count: item.$meta.occupied_zones[zone.code]}) }}</b-badge>
                    <b-button v-else @click="removeZone(i)" size="sm" variant="link" class="text-danger">
                        {{ $t("locations.layout.remove-zone") }}
                    </b-button>
                </div>
            </div>
            
        </div>

        <b-button @click="addZone" variant="light" class="w-100">
            {{ $t("locations.layout.add-zone") }}
        </b-button>

    </b-card>
</template>

<script>
import FormInput from "@/components/Form/Input";
import Location from "@/resources/Location";

const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

export default {
      components: {FormInput},
    data() {
        return {
            internalValue: this.value ?? []
        };
    },
    props: {
        value: {
            type: Array,
            default: null
        },
        item: {
            type: Location,
            required: true
        }
    },
    computed: {
    },
    watch: {
        internalValue: {
            handler(value) {
                this.$emit('input',value)
            },
            deep: true
        }
    },
    methods: {
        addZone() {
            const code = letters.find(l => !this.internalValue.find(z => z.code === l)) || 'Z'

            this.internalValue.push({
                code: code,
                label: null,
                racks: 1,
                shelves: 3,
            })

            this.internalValue.sort((a,b) => a.code.localeCompare(b.code))
        },
        removeZone(i) {
            this.internalValue.splice(i,1)
        }
    }
}
</script>